import React from 'react'

export function GlobalStyles(): React.ReactElement {
  return (
    <style>{`
      @keyframes fadeIn {
        from { opacity: 0; transform: translateY(8px); }
        to   { opacity: 1; transform: translateY(0); }
      }
      .screen-enter {
        animation: fadeIn 0.18s ease-out forwards;
      }
      @keyframes scaleIn {
        from { opacity: 0; transform: scale(0.97); }
        to   { opacity: 1; transform: scale(1); }
      }
      .screen-enter-scale {
        animation: scaleIn 0.15s ease-out forwards;
      }
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50%       { opacity: 0.6; }
      }
      .btn-loading {
        animation: pulse 1s ease-in-out infinite;
        pointer-events: none;
        opacity: 0.7;
      }

      /* Skip-to-content link (hidden until focused) */
      .skip-link {
        position: absolute; top: -100%; left: 0;
        background: #C9A84C; color: #000; padding: 8px 16px;
        font-weight: bold; z-index: 9999; border-radius: 0 0 8px 0;
        transition: top 0.1s;
        text-decoration: none;
      }
      .skip-link:focus { top: 0; }

      /* Visible focus ring for keyboard users */
      :focus-visible {
        outline: 3px solid #C9A84C !important;
        outline-offset: 2px !important;
      }

      /* Remove focus ring for mouse users (only show for keyboard) */
      :focus:not(:focus-visible) { outline: none !important; }

      /* Screen-reader only (visually hidden) */
      .sr-only {
        position: absolute; width: 1px; height: 1px;
        padding: 0; margin: -1px; overflow: hidden;
        clip: rect(0,0,0,0); white-space: nowrap; border: 0;
      }

      /* High contrast text helper */
      .text-contrast {
        text-shadow: 0 1px 3px rgba(0,0,0,0.9);
      }

      /* Reduce motion for users who prefer it */
      @media (prefers-reduced-motion: reduce) {
        .screen-enter, .screen-enter-scale { animation: none !important; }
        * { transition-duration: 0.01ms !important; }
      }

      /* Keyboard-navigable button base (in addition to existing styles) */
      button:focus-visible, [role="button"]:focus-visible {
        outline: 3px solid #C9A84C !important;
        outline-offset: 3px !important;
      }
    `}</style>
  )
}
